import { SkillLevelValuesEnum } from 'types/generated/client';
import { convertTennisRating } from './convert';
import { TennisConvertOptions, TennisRatingSystem, TennisTierInfo } from './types';

export const TENNIS_TIERS: Record<SkillLevelValuesEnum, TennisTierInfo> = {
  [SkillLevelValuesEnum.DoNotPlay]: {
    id: 'brand_new',
    label: 'Not playing yet',
    description: 'Has not started playing tennis.',
  },
  [SkillLevelValuesEnum.BrandNew]: {
    id: 'brand_new',
    label: 'Brand new',
    description: 'Learning to make contact and keep the ball in the court.',
  },
  [SkillLevelValuesEnum.Beginner]: {
    id: 'beginner',
    label: 'Beginner',
    description: 'Sustains short rallies; serves go in but lack pace and placement.',
  },
  [SkillLevelValuesEnum.Intermediate]: {
    id: 'intermediate',
    label: 'Intermediate',
    description: 'Reliable groundstrokes, working second serve, basic strategy and net play.',
  },
  [SkillLevelValuesEnum.Advanced]: {
    id: 'advanced',
    label: 'Advanced',
    description:
      'Variety on serve, dependable approach shots and volleys, tournament-level shot selection.',
  },
  [SkillLevelValuesEnum.Pro]: {
    id: 'pro',
    label: 'Pro',
    description:
      'Open-level / college-elite caliber; pro-grade pace, control, and tactical execution.',
  },
  [SkillLevelValuesEnum.NoResponse]: {
    id: 'intermediate',
    label: 'Unspecified',
    description: 'Skill level not yet provided.',
  },
};

/**
 * Map any tennis rating onto our shared SkillLevel tier by normalizing to UTR,
 * which the app already treats as the canonical tennis rating scale (see
 * NORMALIZED_RATING_SYSTEM_SHORT_NAME in constants/sports.ts).
 */
export const tennisRatingToSkillLevel = (
  inputValue: number,
  fromSystem: TennisRatingSystem,
  options: TennisConvertOptions = {},
): SkillLevelValuesEnum => {
  const conversions = convertTennisRating(inputValue, fromSystem, options);
  const utr = conversions.find((c) => c.system === 'utr');
  const utrValue = utr ? utr.value : inputValue;

  if (utrValue < 2.0) return SkillLevelValuesEnum.BrandNew;
  if (utrValue < 4.0) return SkillLevelValuesEnum.Beginner;
  if (utrValue < 7.0) return SkillLevelValuesEnum.Intermediate;
  if (utrValue < 11.0) return SkillLevelValuesEnum.Advanced;
  return SkillLevelValuesEnum.Pro;
};

export const tennisSkillLevelTierInfo = (level: SkillLevelValuesEnum): TennisTierInfo => {
  return TENNIS_TIERS[level];
};
